export default __webpack_public_path__ + "static/media/CurrentStageDownClosed.432912c2.svg";